import React from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Same convention as BatchTableView's STATUS_STYLES/INVOICE_STATUS_STYLES:
// a lowercased-status -> tailwind pill map, falling back to neutral gray.
const STUDENT_STATUS_STYLES = {
  active: 'text-green-700 bg-green-100',
  hold: 'text-red-700 bg-red-100',
  dropped: 'text-red-700 bg-red-100',
  completed: 'text-blue-700 bg-blue-100',
};

const getStudentStatusColor = (status) =>
  STUDENT_STATUS_STYLES[status?.toLowerCase()] || 'text-gray-600 bg-gray-100';

const StudentClassesModal = ({ batchNo, students,  instructorDetails = {}, onClose }) => {
          const { user } = useAuth();
  const currentTrainerEmail = user?.email;
   const isTrainerMatched = instructorDetails.trainerEmail === currentTrainerEmail;


// Convert decimal hours (e.g., 5.07) into "Xh Ym" format
const formatDecimalHoursToTime = (value) => {
  if (value === undefined || value === null || value === "" || value === "N/A") return null;

  const decimalHours = parseFloat(value);
  if (isNaN(decimalHours) || decimalHours < 0) return null;

  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  if (minutes === 60) return `${hours + 1}h 0m`;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};
  return (
    <div className="fixed inset-0 z-50 bg-black/20 backdrop-blur-sm flex items-center  min-h-screen  justify-center">
      <div className="bg-white pt-12 rounded-xl shadow-lg p-4 w-full max-w-md max-h-[90vh]  overflow-y-auto relative">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Batch #{batchNo} Details
        </h2>

        {/* Student Name + Classes Section */}
        <div className="bg-gray-50 p-4 rounded-xl shadow mb-6">
          <h3 className="text-md font-semibold text-gray-700 mb-2">Students</h3>
          <table className="w-full table-auto text-sm border border-gray-200 rounded">
            <thead className="bg-gray-100">
              <tr>
                 <th className="text-left px-4 py-2">#</th>
                <th className="text-left px-4 py-2">Name</th>
                <th className="text-left px-4 py-2">Status</th>
                {/* <th className="text-left px-4 py-2">Classes</th> */}
              </tr>
            </thead>
            <tbody>
              {students.map((student, idx) => (
                <tr key={idx} className="border-t border-gray-200">
                     <td className="px-4 py-2">{idx + 1}</td>
                  <td className="px-4 py-2">{student.name}</td>
                  <td className="px-4 py-2">
                    {student.studentStatus ? (
                      <span
                        className={`px-2.5 py-1 rounded-full text-xs font-medium ${getStudentStatusColor(student.studentStatus)}`}
                      >
                        {student.studentStatus}
                      </span>
                    ) : (
                      <span className="text-gray-400 text-xs">N/A</span>
                    )}
                  </td>
                  {/* <td className="px-4 py-2">{student.studentClasses || 'N/A'}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Trainer MOU Section */}
        <div className="bg-gray-50 p-4 rounded-xl shadow">
          <h3 className="text-md font-semibold text-gray-700 mb-2">Trainer MOU Details</h3>
          <table className="w-full table-auto text-sm border border-gray-200 rounded">
            <thead className="bg-gray-100">
              <tr>
                {/* <th className="text-left px-4 py-2">Trainer</th> */}
                <th className="text-left px-4 py-2">MOU Hours</th>
                <th className="text-left px-4 py-2">Attended Hours</th>
                <th className="text-left px-4 py-2">Leaves</th>
                

                <th className="text-left px-4 py-2">MOU Amount</th>
              </tr>
            </thead>
           <tbody>
            {isTrainerMatched ? (
  <tr>
    {/* <td className="px-4 py-2">{instructorDetails.name}</td> */}
    <td className="px-4 py-2">{instructorDetails.mouHours || 'N/A'}</td>
    {/* <td className="px-4 py-2">{instructorDetails.attendedHours || 'N/A'}</td> */}
    <td className="px-4 py-2">
      {formatDecimalHoursToTime(instructorDetails.attendedHours) || 'N/A'}
    </td>
    <td className="px-4 py-2">{instructorDetails.trainerLeaves || 'N/A'}</td>


    <td className="px-4 py-2">{instructorDetails.mouAmount || 'N/A'}</td>
  </tr>
) : (
  <tr>
    <td className="px-4 py-2 text-gray-500" colSpan={3}>
      You are not assigned as a trainer for this batch.
    </td>
  </tr>
)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StudentClassesModal;
